import { Avatar, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import React from "react";
import type { FamilyNavigatorCandidate } from "../Widgets/AssignedClinicians/AssignFamilyNavigator";

interface AssignFamilyNavigatorConfirmDialogProps {
  open: boolean;
  closeDialog: () => void;
  selectedFamilyNavigator: Pick<FamilyNavigatorCandidate, "id" | "name">;
  submitAssignment: () => void;
  confirmSent: boolean;
}

const getInitials = (name: string): string => {
  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((namePart) => namePart[0].toUpperCase())
    .join("");
};

const AssignFamilyNavigatorConfirmDialog = ({
  open,
  closeDialog,
  selectedFamilyNavigator,
  submitAssignment,
  confirmSent,
}: AssignFamilyNavigatorConfirmDialogProps) => {
  return (
    <Dialog open={open} onClose={closeDialog} aria-labelledby="family-navigator-confirm-dialog">
      <DialogTitle id="family-navigator-confirm-dialog">Confirm Family Navigator Assignment</DialogTitle>
      <DialogContent>
        <Stack direction="row" gap={5} alignItems="center">
          <Avatar>{getInitials(selectedFamilyNavigator.name)}</Avatar>
          <Typography component="p" variant="body1">
            You have selected {selectedFamilyNavigator.name} to be the Family Navigator.
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={submitAssignment} color="primary" disabled={confirmSent}>
          Confirm
        </Button>
        <Button onClick={closeDialog} color="secondary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssignFamilyNavigatorConfirmDialog;
